import { cn } from "@/lib/utils";

interface SkillRefChipProps {
  label: string;
  className?: string;
}

export function SkillRefChip({ label, className }: SkillRefChipProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border border-(color:--border-decorative,var(--border-strong)) px-3 py-1 text-xs font-medium text-muted-foreground whitespace-nowrap",
        className
      )}
    >
      {label}
    </span>
  );
}
